import React from 'react'
import Resourcepage from '../components/Resourcepage/Resourcepage'

function Resources() {
  return (
    <div>
      <Resourcepage/>
      
    </div>
  )
}

export default Resources
